import api from "@/api.js";

export default {
  namespaced: true,
  state: {
    list: [],
    listLoading: false,
    current: {},
    currentLoading: false,
    listForCompetition: [],
    listForCompetitionLoading: false,
    baseUrl: "arenas"
  },
  mutations: {
    setList(state, payload) {
      state.list = payload;
    },
    setListLoading(state, payload) {
      state.listLoading = payload;
    },
    setCurrent(state, payload) {
      state.current = payload;
    },
    setCurrentLoading(state, payload) {
      state.currentLoading = payload;
    },
    setListForCompetition(state, payload) {
      state.listForCompetition = payload;
    },
    setListForCompetitionLoading(state, payload) {
      state.listForCompetitionLoading = payload;
    }
  },
  actions: {
    async loadAll({ state, commit }) {
      commit("setListLoading", true);
      let list = await api.get(`${state.baseUrl}`);
      commit("setList", list.data);
      commit("setListLoading", false);
    },
    async loadByID({ state, commit }, id) {
      commit("setCurrentLoading", true);
      let response = await api.get(`${state.baseUrl}/byID`, { params: { id: id } });
      commit("setCurrent", response.data[0]);
      commit("setCurrentLoading", false);
    },
    async loadForCompetition({ state, commit }, id) {
      commit("setListForCompetitionLoading", true);
      let response = await api.get(`${state.baseUrl}/forCompetition`, {
        params: { id: id }
      });
      commit("setListForCompetition", response.data);
      commit("setListForCompetitionLoading", false);
    },
    async new({ state, dispatch }, payload) {
      let returnData = {};
      await api
        .post(`${state.baseUrl}`, payload)
        .then(response => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data
            };
          }
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: err
          };
        });
      dispatch("loadAll");
      dispatch("loadForCompetition", payload.competitions_id);
      return returnData;
    },
    async save({ state, dispatch }, payload) {
      let returnData = {};
      await api
        .put(`${state.baseUrl}`, payload)
        .then(response => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data
            };
          }
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: {
              Message: "There was an Error, Please try again later"
            }
          };
        });
      dispatch("loadAll");
      dispatch("loadForCompetition", payload.competitions_id);
      return returnData;
    },
    async delete({ state, dispatch }, payload) {
      let returnData = {};
      await api
        .post(`${state.baseUrl}/delete`, payload)
        .then(response => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data
            };
          }
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: {
              Message: "There was an Error, Please try again later"
            }
          };
        });
      dispatch("loadForCompetition", payload.competitions_id);
      return returnData;
    },
  },
  getters: {
    list(state) {
      return state.list;
    },
    listLoading(state) {
      return state.listLoading;
    },
    current(state) {
      return state.current;
    },
    currentLoading(state) {
      return state.currentLoading;
    },
    listForCompetition(state) {
      return state.listForCompetition;
    },
    listForCompetitionLoading(state) {
      return state.listForCompetitionLoading;
    },
    listDictionaryForCompetition(state) {
      let returnData = {};
      state.listForCompetition.forEach(arena => {
        returnData[arena.id] = arena.name;
      });
      return returnData;
    }
  }
};
